import { apiSlice } from '../apiSlice';
import { DeleteResponse } from '../schemas/apiResponse';
import { Role } from '../schemas/user';

const ROLES_PATH = '/roles';

const userEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addRole: builder.mutation<Role, Partial<Role>>({
      query: (body) => ({
        url: ROLES_PATH,
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'User', id: 'LIST' }], // user object has roles array
    }),
    deleteRole: builder.mutation<DeleteResponse, number>({
      query(id) {
        return {
          url: `${ROLES_PATH}/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: () => [{ type: 'User', id: 'LIST' }], // user object has roles array
    }),
  }),
});

export const { useAddRoleMutation, useDeleteRoleMutation } = userEndpoints;
